/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteSurveyContactHistoryAsync$Json$Params {

/**
 * surveycontacthistory id
 */
  surveyContactHistoryId: number;
}

export function deleteSurveyContactHistoryAsync$Json(http: HttpClient, rootUrl: string, params: DeleteSurveyContactHistoryAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, deleteSurveyContactHistoryAsync$Json.PATH, 'delete');
  if (params) {
    rb.path('surveyContactHistoryId', params.surveyContactHistoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

deleteSurveyContactHistoryAsync$Json.PATH = '/api/SurveyContactHistory/{surveyContactHistoryId}';
